// services/productService.js
import { database, storage } from "../../FirebaseConfig";
import { ref as databaseRef, set, update } from "firebase/database";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

// Version simplifiée pour uploader l'image sans boucles infinies
export const uploadProductImage = async (file) => {
  try {
    // Vérifier si le fichier est valide
    if (!file || !(file instanceof File)) {
      throw new Error("Fichier invalide");
    }
    
    // Créer un nom unique pour l'image
    const timestamp = new Date().getTime();
    const fileName = `product_images/${timestamp}_${file.name}`;
    
    // Créer une référence Storage
    const imageRef = storageRef(storage, fileName);
    
    // Upload direct du fichier sans optimisation
    const snapshot = await uploadBytes(imageRef, file);
    
    // Obtenir l'URL de téléchargement
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return downloadURL;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image:", error);
    throw new Error("Erreur d'upload: " + error.message);
  }
};

export const saveProductData = async (productData, idGroup, idUser) => {
  try {
    // Upload de l'image d'abord si elle existe
    let imageUrl = null;
    if (productData.image instanceof File) {
      imageUrl = await uploadProductImage(productData.image);
    }

    // Générer un ID unique pour le produit
    const productId = Date.now().toString();
    
    // Créer une référence à l'emplacement dans la base de données
    const productRef = databaseRef(database, `products/${idUser}/${productId}`);
    
    // Préparer les données à sauvegarder
    const data = {
      id: productId,
      title: productData.titre,
      price: Number(productData.prix),
      description: productData.description || "",
      duration: productData.duree,
      imageUrl: imageUrl,
      idGroup,
      idUser,
      status: "active",
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    };

    // Sauvegarder les données
    await set(productRef, data);
    console.log("Produit sauvegardé avec succès");
    return { success: true, productId, imageUrl };
  } catch (error) {
    console.error("Erreur lors de la sauvegarde du produit:", error);
    throw error;
  }
};

// Fonction pour mettre à jour un produit existant
export const updateProductData = async (productId, productData, idUser) => {
  try {
    // Upload de l'image d'abord si elle existe
    let imageUrl = null;
    if (productData.image instanceof File) {
      imageUrl = await uploadProductImage(productData.image);
    }
    
    // Créer une référence à l'emplacement dans la base de données
    const productRef = databaseRef(database, `products/${idUser}/${productId}`);
    
    // Préparer les données à mettre à jour
    const data = {
      title: productData.titre,
      price: Number(productData.prix),
      description: productData.description || "",
      duration: productData.duree,
      updated_at: new Date().toISOString()
    };
    
    // Ajouter l'URL de l'image seulement si une nouvelle image a été uploadée
    if (imageUrl) {
      data.imageUrl = imageUrl;
    }

    // Mettre à jour les données
    await update(productRef, data);
    console.log("Produit mis à jour avec succès");
    return { success: true, productId, imageUrl };
  } catch (error) {
    console.error("Erreur lors de la mise à jour du produit:", error);
    throw error;
  }
};